import { render, staticRenderFns } from "./AwaitingTicketDetails.vue?vue&type=template&id=5ba54e4a"
import script from "./AwaitingTicketDetails.vue?vue&type=script&lang=js"
export * from "./AwaitingTicketDetails.vue?vue&type=script&lang=js"
import style0 from "./AwaitingTicketDetails.vue?vue&type=style&index=0&id=5ba54e4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports